import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/Error';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import gatewayClient from '@cedalo/webui/src/helper/GatewayClient';

const IMPORT_ACTION = 'timescale.action.import';

const FILE_UPLOAD = `
	mutation FileUpload($machineId: String!, $file: Upload!) {
		uploadFile(machineId: $machineId, file: $file)	{
			success
			message
		}
	}
`;
const FILE_DELETE = `
	mutation FileRemove($machineId: String!, $filename: String!) {
		deleteUploadedFile(machineId: $machineId, filename: $filename)	{
			success
			message
		}
	}
`;
const uploadFile = async (machineId, file) => {
	const result = await gatewayClient.graphql(FILE_UPLOAD, { machineId, file: null }, file);
	const { success, message } = result.data.uploadFile;
	if (!success) throw new Error(message);
	return file.name;
};
const deleteUploadedFile = async (machineId, filename) => {
	try {
		await gatewayClient.graphql(FILE_DELETE, { machineId, filename });
	} catch (err) {
		/* ignore */
		console.error('Removal of uploaded file failed!', err);
	}
};
const requestTimescaleImport = async (machineId, table, filename, fileSettings) => {
	const response = await gatewayClient.sendMachineAction(machineId, {
		type: IMPORT_ACTION,
		data: { fileName: `${machineId}/${filename}`, fileSettings, table }
	});
	// verify result
	const { result, error } = response.machineserver;
	if (error) throw new Error(error.message || 'Failed to import file to timescale table');
	return result;
};

const TimescaleRunImportDialog = (props) => {
	const { onImportDone, open, file, fileSettings, machineId, table } = props;
	const [state, setState] = useState({ done: false, error: null });

	useEffect(() => {
		const doImport = async () => {
			let filename;
			const newState = { ...state };
			try {
				filename = await uploadFile(machineId, file);
				await requestTimescaleImport(machineId, table, filename, fileSettings);
			} catch (error) {
				console.error('ERROR during timescale import!', error);
				newState.error = error.message;
			} finally {
				newState.done = true;
				if (filename) await deleteUploadedFile(machineId, filename);
			}
			setState(newState);
		};
		if (open) doImport();
	}, [open]);

	const onClose = () => {
		setState({ done: false, error: null });
		onImportDone();
	};

	const stateIcon = state.error ? (
		<ErrorIcon style={{ color: 'red', width: '48px', height: '48px' }} />
	) : (
		<CheckIcon style={{ color: 'green', width: '48px', height: '48px' }} />
	);
	const stateHint = state.done ? stateIcon : <CircularProgress />;
	const stateErrorSuccessText = state.error ? (
		<React.Fragment>
			<FormattedMessage id="Extensions.TimescaleImport.ImportFailed" defaultMessage="Import failed!" />
			<br />
			{`${state.error}`}
		</React.Fragment>
	) : (
		<FormattedMessage id="Extensions.TimescaleImport.ImportSuccess" defaultMessage="Import successful!" />
	);
	const stateText = state.done ? (
		stateErrorSuccessText
	) : (
		<FormattedMessage id="Extensions.TimescaleImport.ImportingFile" defaultMessage="Importing file..." />
	);

	return (
		<Dialog fullWidth mode="indeterminate" size={50} open={open}>
			<DialogContent style={{ textAlign: 'center' }}>
				{stateHint}
				<div>
					<DialogContentText>{stateText}</DialogContentText>
				</div>
			</DialogContent>
			{state.done ? (
				<DialogActions style={{ justifyContent: 'center' }}>
					<Button color="primary" onClick={onClose}>
						<FormattedMessage id="Extensions.Button.Ok" defaultMessage="Ok" />
					</Button>
				</DialogActions>
			) : null}
		</Dialog>
	);
};

export default TimescaleRunImportDialog;



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/timescale/RunImportDialog.js